import { render } from "./goods.vue?vue&type=template&id=2e6786f2&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"

import "./goods.vue?vue&type=style&index=0&id=2e6786f2&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/root/qzf/src/invoice-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6786f2"]])

export default __exports__